import { cn } from '@/utils/сn';

type CalendarNextUpPanelSkeletonProps = {
  showFooterCta?: boolean;
};

function SkeletonBar({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded bg-grey-200', className)} aria-hidden />;
}

export function CalendarNextUpContentSkeleton() {
  return (
    <div className="flex flex-col gap-3" aria-busy aria-label="Loading schedule">
      <SkeletonBar className="h-7 w-40 rounded-[100px]" />
      <SkeletonBar className="h-7 w-48 rounded-[100px]" />
      <SkeletonBar className="h-10 w-full rounded-md" />
      <SkeletonBar className="h-10 w-full rounded-md" />
      <SkeletonBar className="h-12 w-full rounded-md" />
    </div>
  );
}

export function CalendarNextUpPanelSkeleton({ showFooterCta = false }: CalendarNextUpPanelSkeletonProps) {
  return (
    <aside
      className="flex h-auto w-full shrink-0 flex-col self-stretch rounded-[14px] border border-grey-300 bg-white shadow-card md:h-full md:min-h-0"
      aria-busy
      aria-label="Loading schedule summary"
    >
      <div className="flex shrink-0 flex-col gap-3 px-5 pt-5 pb-4">
        <div className="flex flex-col gap-2">
          <SkeletonBar className="h-5 w-24" />
          <SkeletonBar className="h-4 w-36" />
        </div>
        <div className="flex flex-col gap-2.5">
          <SkeletonBar className="h-5 w-28" />
          <SkeletonBar className="h-5 w-32" />
          <SkeletonBar className="h-5 w-24" />
        </div>
      </div>

      <div className="flex flex-col gap-3 px-4 pb-5 md:min-h-0 md:flex-1">
        <div className="flex items-center gap-4">
          <SkeletonBar className="h-px min-w-0 flex-1" />
          <SkeletonBar className="h-4 w-16 shrink-0" />
          <SkeletonBar className="h-px min-w-0 flex-1" />
        </div>

        <CalendarNextUpContentSkeleton />

        {showFooterCta ? <SkeletonBar className="h-10 w-full rounded-lg md:mt-auto" /> : null}
      </div>
    </aside>
  );
}
